import { render, staticRenderFns } from "./r-quest-dialog.vue?vue&type=template&id=10d9b114&scoped=true"
import script from "./r-quest-dialog.vue?vue&type=script&lang=js"
export * from "./r-quest-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-quest-dialog.vue?vue&type=style&index=0&id=10d9b114&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d9b114",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10d9b114')) {
      api.createRecord('10d9b114', component.options)
    } else {
      api.reload('10d9b114', component.options)
    }
    module.hot.accept("./r-quest-dialog.vue?vue&type=template&id=10d9b114&scoped=true", function () {
      api.rerender('10d9b114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/quest/r-quest-dialog.vue"
export default component.exports